import { FC } from 'react';

import type { ButtonModel } from '../../../types';
import BoxButton from '../../Button/Box';

const FullWidth: FC<React.PropsWithChildren<React.PropsWithChildren<Omit<ButtonModel, 'size' | 'icon' | 'color'>>>> = (props) => {
  return <BoxButton fullWidth {...props} />;
};

export default FullWidth;
